import * as React from "react";
import PageHeaderView from "../body/PageHeaderView";
import PageContentView from "../body/PageContentView";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import Routes from "../../navigation/route/Route";
import {connect, Dispatch} from "react-redux";
import {RootState} from "../../store/reducer/root/RootState";
import {Option} from "ts-option";
import Loading from "../ui/loading/Loading";
import EditContactForm from "./form/edit/EditContactForm";
import {getIndividualContact} from "../../store/view/contact";
import IndividualContact from "../../model/contact/IndividualContact";
import {OnFailure, OnSuccessData} from "../../store/action/actionHelpers";
import {fetchIndividualContact} from "../../store/action/contacts/contacts";
import {Boxed} from "../../hiberUiKit/src/molecules/Boxed/Boxed";

interface RouteProps {
	/**
	 * Contact identifier.
	 */
	contactId: string
}

type ComponentProps = RouteComponentProps<RouteProps>;

interface ReduxProps {
	/**
	 * Contact data.
	 */
	contact: Option<IndividualContact>;
}

interface DispatchProps {
	/**
	 * Fetch contact.
	 * @param {string} contactId
	 * @param {OnSuccessData} onSuccess
	 * @param {OnFailure} onFailure
	 */
	fetchContact: (contactId: string, onSuccess: OnSuccessData<IndividualContact>, onFailure: OnFailure) => void;
}

interface State {
	/**
	 * Contact fething in progress.
	 */
	contactFetching: boolean;
	/**
	 * Contact fetched.
	 */
	contactFetched: boolean;
}

type Props = ComponentProps & ReduxProps & DispatchProps;

/**
 * Contact details component.
 */
class ContactDetails extends React.PureComponent <Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {contactFetched: false, contactFetching: false};
		this.onSuccess = this.onSuccess.bind(this);
		this.checkContactExistence = this.checkContactExistence.bind(this);
	}

	componentDidMount() {
		this.checkContactExistence();
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={"Edit Contact"}/>
				<PageContentView>
					<Loading isLoading={this.props.contact.isEmpty}>
						{this.props.contact.map(
							contact => <EditContactForm onSuccess={this.onSuccess} contact={contact}/>).orNull}
					</Loading>
				</PageContentView>
			</Boxed>
		);
	}

	/**
	 * On successfully modified contact.
	 */
	private onSuccess() {
		this.props.history.push(Routes.ContactsList);
	}

	/**
	 * If no contact, try to fetch contact again. If there is still no contact, redirect to the contact list
	 */
	checkContactExistence() {
		if (this.props.contact.isEmpty) {
			if (this.state.contactFetched) {
				this.props.history.push(Routes.ContactsList);
			}
			else if (!this.state.contactFetching) {
				this.setState({contactFetching: true},
					() => this.props.fetchContact(this.props.match.params.contactId,
						() => {this.setState({contactFetched: true, contactFetching: false})},
						() => this.props.history.push(Routes.ContactsList))
				);
			}
		}
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchContact: (contactId: string, onSuccess: OnSuccessData<IndividualContact>, onFailure: OnFailure) => dispatch(
			fetchIndividualContact(contactId, onSuccess, onFailure))
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	return ({
		contact: getIndividualContact(props.match.params.contactId, state)
	})
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactDetails));